import React, { Component } from 'react';
/* eslint-disable */
import { Card, CardBody, Col } from 'reactstrap';

class Activet extends Component {
	componentDidMount() {
		if (localStorage.profile_completed === '0') {
			localStorage.setItem('came_from', 'activet');
			this.props.history.push({
				pathname: '/profile',
				backTo: '/',
			});
		}
	}
	render() {
		return (
			<Col md={12}>
				<Card>
					<CardBody>
						<div className="card__title">
							<h5 className="bold-text">Active Tickets</h5>
						</div>
						<p>Your content here</p>
					</CardBody>
				</Card>
			</Col>
		);
	}
}

export default Activet;
